import React from 'react';
import * as Styles from './AiChatFullSreenHandler.styles';
import { useAiChat } from '@/hooks/AiChat';

export const AiChatFullScreenHandler = () => {
  const { handleRenderFullScreenAiChat } = useAiChat();
  return (
    <Styles.Container>
      {handleRenderFullScreenAiChat()}
    </Styles.Container>
  );
};

export default AiChatFullScreenHandler;
